import { render, staticRenderFns } from "./AddDomainDialog.vue?vue&type=template&id=9c1c714a&"
import script from "./AddDomainDialog.vue?vue&type=script&lang=js&"
export * from "./AddDomainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports